import { render, staticRenderFns } from "./ClasseList.vue?vue&type=template&id=a7258978"
import script from "./ClasseList.vue?vue&type=script&lang=js"
export * from "./ClasseList.vue?vue&type=script&lang=js"
import style0 from "./ClasseList.vue?vue&type=style&index=0&id=a7258978&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports